(() => {
  if (window.SVPreorderGuard) return;

  const modal = document.getElementById('sv-preorder-modal');
  const configNode = document.getElementById('sv-preorder-config');
  if (!modal || !configNode) return;

  let config = {};
  try { config = JSON.parse(configNode.textContent); } catch (error) { console.error(error); }

  const checkbox = modal.querySelector('#sv-preorder-agree');
  const continueButton = modal.querySelector('#sv-preorder-continue');
  const dispatchValue = modal.querySelector('#sv-preorder-dispatch-value');
  const dialog = modal.querySelector('.sv-preorder-box');
  let pendingAction = null;
  let processing = false;
  let lastFocusedElement = null;

  const normalizeDispatches = (values = []) => [...new Set(values.map(v => String(v || '').trim()).filter(Boolean))];
  const resolveDispatch = (values = []) => {
    const unique = normalizeDispatches(values);
    if (unique.length === 0) return config.defaultDispatch || '';
    if (unique.length === 1) return unique[0];
    return config.multipleDispatch || config.defaultDispatch || '';
  };

  const setProcessing = (value) => {
    processing = value;
    continueButton.textContent = value ? config.processingText : config.continueText;
    continueButton.disabled = value || !checkbox.checked;
  };

  const open = (action, dispatches = []) => {
    if (!config.enabled || processing) {
      action?.proceed?.();
      return;
    }
    pendingAction = action;
    lastFocusedElement = document.activeElement;
    checkbox.checked = false;
    continueButton.textContent = config.continueText;
    continueButton.disabled = true;
    dispatchValue.textContent = resolveDispatch(dispatches);
    modal.hidden = false;
    document.documentElement.classList.add('sv-modal-open');
    document.body.classList.add('sv-modal-open');
    requestAnimationFrame(() => {
      modal.classList.add('sv-is-visible');
      dialog.focus({ preventScroll: true });
    });
  };

  const close = () => {
    if (processing) return;
    modal.classList.remove('sv-is-visible');
    modal.hidden = true;
    document.documentElement.classList.remove('sv-modal-open');
    document.body.classList.remove('sv-modal-open');
    pendingAction = null;
    lastFocusedElement?.focus?.({ preventScroll: true });
  };

  const buyNowCheckout = async ({ button, form }) => {
    button.disabled = true;
    try {
      const formData = new FormData(form);
      await fetch('/cart/clear.js', { method:'POST', headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'} });
      const response = await fetch('/cart/add.js', { method:'POST', body:formData, headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'} });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || 'Unable to add product to cart.');
      }
      window.SVExperience?.showCheckout?.();
      await new Promise(resolve => setTimeout(resolve, window.SVExperience ? Math.min(window.SVExperience.duration, 420) : 0));
      window.location.assign('/checkout');
    } catch (error) { button.disabled = false; throw error; }
  };

  const getCartPreorderInfo = async () => {
    const response = await fetch('/cart.js', { headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}, cache:'no-store' });
    if (!response.ok) throw new Error('Unable to check the cart.');
    const cart = await response.json();
    const preorderItems = cart.items.filter(item => {
      const value = item.properties && item.properties._sv_preorder;
      return value === true || value === 'true';
    });
    return {
      hasPreorder: preorderItems.length > 0,
      dispatches: preorderItems.map(item => item.properties && item.properties._sv_dispatch)
    };
  };

  const handleBuyNow = ({ button, form, isPreorder, dispatch }) => {
    if (processing || button.disabled) return;
    const proceed = () => buyNowCheckout({ button, form }).catch(error => {
      console.error('Stately Velour Buy Now error:', error);
      alert(error.message || 'Something went wrong. Please try again.');
    });
    if (config.enabled && isPreorder) open({ proceed }, [dispatch]); else proceed();
  };

  document.addEventListener('click', async event => {
    if (event.target.closest('[data-sv-preorder-close]')) { close(); return; }
    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutButton || checkoutButton.closest('#sv-preorder-modal')) return;
    event.preventDefault(); event.stopPropagation();
    if (processing || checkoutButton.disabled) return;
    checkoutButton.disabled = true;
    try {
      const info = await getCartPreorderInfo();
      const proceed = async () => {
        window.SVExperience?.showCheckout?.();
        await new Promise(resolve => setTimeout(resolve, window.SVExperience ? Math.min(window.SVExperience.duration, 420) : 0));
        window.location.assign('/checkout');
      };
      checkoutButton.disabled = false;
      if (config.enabled && info.hasPreorder) open({ proceed }, info.dispatches); else proceed();
    } catch (error) {
      console.error('Stately Velour cart checkout error:', error);
      checkoutButton.disabled = false;
      alert(error.message || 'Something went wrong. Please try again.');
    }
  }, true);

  document.addEventListener('change', event => {
    if (event.target === checkbox) continueButton.disabled = !checkbox.checked || processing;
  });

  continueButton.addEventListener('click', async () => {
    if (!pendingAction || continueButton.disabled || processing) return;
    setProcessing(true);
    try { await pendingAction.proceed(); }
    catch (error) {
      console.error('Stately Velour checkout error:', error);
      setProcessing(false);
      alert(error.message || 'Something went wrong. Please try again.');
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') close();
    if (event.key === 'Tab' && !modal.hidden) {
      const focusable = [...modal.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')];
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  window.SVPreorderGuard = { handleBuyNow, open, close };
})();
